import {Capacitor} from '@capacitor/core';
// REST credentials are memory-only on iOS, just like the Firebase SDK session.
// Web and Android behavior remains unchanged in this iOS-only slice.
let memory: string|null=null;
export const restAuthStorage={
 getItem:(_key:string)=>Capacitor.getPlatform()==='ios'?memory:localStorage.getItem('finflow_auth'),
 setItem:(_key:string,value:string)=>{if(Capacitor.getPlatform()==='ios'){memory=value;localStorage.removeItem('finflow_auth');}else localStorage.setItem('finflow_auth',value);},
 removeItem:(_key:string)=>{memory=null;localStorage.removeItem('finflow_auth');}
};
